export const classes = {
  listPreview: 'rounded-lg size-12 object-contain overflow-hidden',
  auroraIcon:
    'size-10 shrink-0 place-center overflow-hidden rounded-xl bg-black/[0.04] dark:bg-white/[0.06]',
  auroraPreview: 'size-full object-cover',
  gridPreview: 'size-full object-contain',
  card: 'place-start p-3 my-0.5 bg-white dark:bg-[#332e43] text-grey-8 dark:text-mauve-1 cursor-pointer rounded-xl border-2 border-transparent hover:shadow-md transition-all duration-150',
  auroraCard:
    'place-start p-3 my-0.5 cursor-pointer rounded-xl border-2 border-transparent transition-colors hover:bg-black/[0.05] dark:hover:bg-white/[0.06]',
  auroraActive:
    'border-brand-accent/70 bg-brand-accent/[0.08] hover:bg-brand-accent/[0.08]',
  auroraCardTitle:
    'text-sm font-medium text-taupe-3 cursor-pointer dark:text-mauve-1',
  cardDense: 'p-1.5',
  active: 'border-orange-3 hover:border-orange-3',
  content: 'place-start gap-4 min-w-0 w-full',
  contentDense: 'gap-2',
  titleWrapper: 'grow',
  title: 'text-sm font-medium text-grey-8 dark:text-mauve-1 cursor-pointer',
  optionsWrapper: 'place-center shrink-0',
  optionsIcon: 'options-icon cursor-pointer text-taupe-2 dark:text-mauve-2',
  optionsIconOpen: '!w-6',
};

export const styles = {
  card: {
    '& .options-icon': {
      width: 0,
      transition: 'width 0.2s',
    },
    '&:hover .options-icon': {
      width: 24,
    },
  },
};
